import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import api from "../api";
import { REFRESH_TOKEN, ACCESS_TOKEN } from "../constants";
import { useState, useEffect } from "react";


function ProtectedRoute({ children }) {
    const [isAuthorized, setIsAuthorized] = useState(null);
    const [canAccessHere, setCanAccessHere] = useState(null);

    useEffect(() => {
        auth().catch(() => { setIsAuthorized(false); setCanAccessHere(false); })
    }, [])

    const refreshToken = async () => {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN);
        try {
            const res = await api.post("token/refresh/", {
                refresh: refreshToken,
            });
            if (res.status === 200) {
                localStorage.setItem(ACCESS_TOKEN, res.data.access)
                setIsAuthorized(true)
            } else {
                setIsAuthorized(false)
            }
        } catch (error) {
            console.log(error);
            localStorage.removeItem(ACCESS_TOKEN);
            localStorage.removeItem(REFRESH_TOKEN);
            setIsAuthorized(false);
        }
    };

    const auth = async () => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        if (!token) {
            setIsAuthorized(false);
            return;
        }
        const decoded = jwtDecode(token);
        const tokenExpiration = decoded.exp;
        const now = Date.now() / 1000;

        if (tokenExpiration < now) {
            await refreshToken();
        } else {
            setIsAuthorized(true);
        }
                // Chequeo de gating por plan/resumen_only
                try {
                    const { data } = await api.get('user/profile/');
                    const resumenOnly = !!data?.resumen_only;
                    const planState = String(data?.plan_state || 'unknown');
                    const restricted = resumenOnly || planState === 'expired';
                    const path = (typeof window !== 'undefined' && window.location && window.location.pathname) ? window.location.pathname : '';
                    // Permitir siempre /resumen; /renovacion ya es pública pero lo dejamos como permitido por coherencia
                    if (restricted) {
                        setCanAccessHere(path === '/resumen' || path === '/renovacion');
                    } else {
                        setCanAccessHere(true);
                    }
                } catch {
                    // Si falla el perfil, por defecto permitir (el backend igual reforzará)
                    setCanAccessHere(true);
                }
    };

        if (isAuthorized === null || canAccessHere === null) {
        return <div>Loading...</div>;
    }

        if (!isAuthorized) return <Navigate to="/login" />;
        return canAccessHere ? children : <Navigate to="/resumen" />;
}

export default ProtectedRoute;
